const MobileLayout = ({ children }) => {
  return (
    <div>
      
      {children}
    </div>
  );
};

export default MobileLayout;
